export const EventTypes = {
    PRIVATE: 'private',
    PUBLIC: 'public',
    GROUP: 'group'
};
